package cz.lhoracek.mapl.domain

import cz.lhoracek.mapl.data.model.GameType
import cz.lhoracek.mapl.data.model.Player
import cz.lhoracek.mapl.data.model.Round
import cz.lhoracek.mapl.data.model.Session

data class SessionScoreResult(
    val scores: Map<String, Int>,
    val currentPot: Int,
    val awardedPotByRoundId: Map<String, Int>,
)

object SessionScoreCalculator {

    fun calculate(
        session: Session,
        players: List<Player>,
        rounds: List<Round>,
    ): SessionScoreResult {
        val scores = players.associate { it.id to 0 }.toMutableMap()
        val awardedPotByRoundId = mutableMapOf<String, Int>()
        var pot = 0

        rounds
            .sortedWith(compareBy<Round> { it.timestamp }.thenBy { it.id })
            .forEach { round ->
                if (round.noCaller) {
                    if (session.potEnabled) {
                        val contributionPerPlayer = (if (round.bet > 0) round.bet else session.currentBet) * 2
                        players.forEach { player ->
                            scores[player.id] = (scores[player.id] ?: 0) - contributionPerPlayer
                        }
                        pot += contributionPerPlayer * players.size
                    }
                    return@forEach
                }

                val roundBet = if (round.bet > 0) round.bet else session.currentBet
                val deltas = ScoreCalculator.calculateDeltas(round, players, roundBet)
                deltas.forEach { (playerId, delta) ->
                    scores[playerId] = (scores[playerId] ?: 0) + delta
                }

                val shouldAwardPot = session.potEnabled &&
                    round.won &&
                    (round.gameType == GameType.CTYRI || round.gameType == GameType.MAPL)
                if (shouldAwardPot) {
                    val award = pot
                    if (award > 0 && scores.containsKey(round.actorId)) {
                        scores[round.actorId] = (scores[round.actorId] ?: 0) + award
                    }
                    awardedPotByRoundId[round.id] = award
                    pot = 0
                }
            }

        return SessionScoreResult(
            scores = scores,
            currentPot = if (session.potEnabled) pot else 0,
            awardedPotByRoundId = awardedPotByRoundId,
        )
    }
}
